export const backups = (state) => state.backups
export const totalBackups = (state) => state.totalBackups
export const selectedBackups = (state) => state.selectedBackups
export const selectAllField = (state) => state.selectAllField